var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenes home"},[_c('Intro'),_c('Music'),_c('Shows'),_c('History'),_c('section',{staticClass:"band bandphoto bandphoto3"}),_c('Mailinglist'),_c('section',{staticClass:"band bandphoto bandphoto1"}),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }